import { render, staticRenderFns } from "./CustomersList.vue?vue&type=template&id=21b08014"
import script from "./CustomersList.vue?vue&type=script&lang=js"
export * from "./CustomersList.vue?vue&type=script&lang=js"
import style0 from "./CustomersList.vue?vue&type=style&index=0&id=21b08014&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports